'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var exclamationMark = require('./exclamation-mark-02f43bf2.js');
var asterisk = require('./asterisk-436ee6b3.js');
var fieldHint = require('./field-hint-cc714695.js');
var InputBase = _interopDefault(require('@material-ui/core/InputBase'));
var MaterialSelect = _interopDefault(require('@material-ui/core/Select'));

var StyledSelect = styled__default(MaterialSelect)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  height: 48px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  width: 100%;\n  overflow: hidden;\n  border-color: ", ";\n\n  label {\n    font-weight: ", ";\n  }\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &.Mui-focused {\n    border-color: ", ";\n  }\n\n  &.Mui-disabled {\n    border-color: ", ";\n  }\n\n  .carrot-icon {\n    margin-right: ", ";\n    ", "\n  }\n"], ["\n  height: 48px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  width: 100%;\n  overflow: hidden;\n  border-color: ", ";\n\n  label {\n    font-weight: ", ";\n  }\n\n  &:hover {\n    border-color: ",
    ";\n  }\n\n  &.Mui-focused {\n    border-color: ", ";\n  }\n\n  &.Mui-disabled {\n    border-color: ", ";\n  }\n\n  .carrot-icon {\n    margin-right: ", ";\n    ",
    "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var errored = _a.errored, theme = _a.theme;
    return (errored ? theme.colors.admin.pink : theme.colors.greys.adminGreyMedium);
}, function (_a) {
    var type = _a.type;
    return (type === 'pagination' ? 500 : 400);
}, function (_a) {
    var errored = _a.errored, theme = _a.theme;
    return (errored
        ? theme.colors.admin.pink
        : theme.colors.greys.adminGreyDark);
}, function (_a) {
    var theme = _a.theme;
    return (theme.defaultColors.primary);
}, function (_a) {
    var theme = _a.theme;
    return (theme.colors.greys.adminGreyMedium);
}, function (_a) {
    var errored = _a.errored;
    return (errored ? '40px' : '0px');
}, function (_a) {
    var IconComponent = _a.IconComponent;
    return IconComponent
        && "\n    position: absolute;\n    right: 12px;\n    top: calc(50% - 11px);\n    transform: none;\n    ";
});
var StyledLabel = styled__default.label(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  font-family: ", ";\n  font-size: 16px;\n  line-height: 22px;\n  margin-left: 16px;\n  color: ", ";\n"], ["\n  width: 100%;\n  font-family: ", ";\n  font-size: 16px;\n  line-height: 22px;\n  margin-left: 16px;\n  color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, isSelectActive = _a.isSelectActive;
    return (isSelectActive
        ? theme.colors.greys.adminBlack
        : theme.colors.greys.adminGreyMediumAlt);
});
var StyledSelectContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledExclamationMark = styled__default(exclamationMark.ExclamationMark)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n"])));
var selectMenuProps = {
    marginThreshold: 0,
    MenuListProps: { disablePadding: true },
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
    },
    getContentAnchorEl: null,
};
var Select = function (_a) {
    var className = _a.className, children = _a.children, disabled = _a.disabled, required = _a.required, value = _a.value, selectedValueLabel = _a.selectedValueLabel, dataCy = _a.dataCy, titleComponent = _a.titleComponent, name = _a.name, placeholder = _a.placeholder, errored = _a.errored, _b = _a.footerText, footerText = _b === void 0 ? '' : _b, onChange = _a.onChange, _c = _a.icon, icon = _c === void 0 ? undefined : _c, _d = _a.type, type = _d === void 0 ? 'default' : _d, restProps = tslib_es6.__rest(_a, ["className", "children", "disabled", "required", "value", "selectedValueLabel", "dataCy", "titleComponent", "name", "placeholder", "errored", "footerText", "onChange", "icon", "type"]);
    var renderValue = React.useCallback(function (selectValue) { return (React__default.createElement(StyledLabel, { isSelectActive: !!selectValue && !disabled, className: className + "-label" }, selectedValueLabel || selectValue || placeholder)); }, [disabled, className, selectedValueLabel, placeholder]);
    return (React__default.createElement("div", { className: className },
        required ? React__default.createElement(asterisk.Asterisk, null, titleComponent) : titleComponent,
        React__default.createElement(StyledSelectContainer, null,
            React__default.createElement(StyledSelect, tslib_es6.__assign({ displayEmpty: true, className: className + "-select", name: name, errored: errored, onChange: onChange, "data-cy": dataCy + "-select", "data-testid": "select-field", disabled: disabled, input: React__default.createElement(InputBase, null), value: value, MenuProps: selectMenuProps, renderValue: renderValue, IconComponent: icon, classes: { icon: 'carrot-icon' }, type: type }, restProps), children),
            errored && (React__default.createElement(StyledExclamationMark, { "data-testid": "exclamation-mark-icon", variant: "pink", size: "none", width: 20, height: 20 }))),
        footerText && (React__default.createElement(fieldHint.FieldHint, { className: "hint", variant: errored && !disabled ? 'error' : 'hint' }, footerText))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.Select = Select;
